// extracted by mini-css-extract-plugin
module.exports =  {"ParagraphText":"ParagraphText__555H7"};